import React from "react";
import { HStack, Icon, Text } from "components/ui";
import { InfoIcon, AlertCircle } from "lucide-react-native";

type Props = {
	text: string;
	icon?: "info" | "warning" | "error" | "success";
};

const InfoBox = (props: Props) => {
	// Default values for info variant
	let borderColor = "$primarylight";
	let backgroundColor = "transparent";
	let iconColor = "$primarylight";
	let textColor = "inherit";
	let IconComponent = InfoIcon;

	// Handle different variants
	switch (props.icon) {
		case "warning":
			borderColor = "$errorbright";
			backgroundColor = "$errorlight";
			iconColor = "$errorbright";
			textColor = "$errorbright";
			IconComponent = AlertCircle;
			break;
		// Add cases for other variants (error, success) as needed
	}

	return (
		<HStack padding={12} gap={8} borderRadius={12} width={"$full"} borderWidth={1} borderColor={borderColor} backgroundColor={backgroundColor}>
			<Icon maxWidth={32} flex={1} as={IconComponent} color={iconColor} />
			<Text fontFamily="calibri" fontWeight={"bold"} flex={1} color={textColor}>
				{props.text}
			</Text>
		</HStack>
	);
};

export default InfoBox;
